// extracted by mini-css-extract-plugin
export default {"box":"Bonus_box__a4H+v","description":"Bonus_description__DX4BP","title":"Bonus_title__tURJZ","icon":"Bonus_icon__mWJYC"};